/* ==========================================================================
 * aef-marketdeals.js — REDESIGN homepage behavior.
 *  - Honest cutoff countdown to next 2 PM (same-day dispatch); rolls to tomorrow.
 *  - Flash-deal countdown to end of today.
 *  - Add-to-cart: uses window.aefCartAdd if the theme exposes it, else a plain
 *    /cart/add.js POST fallback (then redirects to /cart).
 * ========================================================================== */
(function(){
  'use strict';

  // Chống chạy hai lần. Shopify Section Rendering API tiêm lại HTML của section
  // (kèm luôn thẻ <script src>) mỗi khi giỏ/filter cập nhật — không có chốt này
  // thì bindAdd() gắn listener lần thứ hai lên document và MỘT cú click thành
  // HAI lần thêm giỏ, cộng thêm một bộ setInterval nữa chạy song song. Đây đúng
  // Pattern 1+6 trong feedback_cart_ui_anti_regression; mọi file đụng giỏ khác
  // của theme (cart-drawer, card-stepper, mini-cart-popup) đều đã có chốt này.
  if (window.__aefMarketDeals) return;
  window.__aefMarketDeals = true;

  function two(n){ return String(n).padStart(2,'0'); }

  // Giờ chốt tính theo GIỜ TRUNG TÂM (giờ kho ở Texas), không phải giờ máy
  // của khách. Dùng thẳng new Date() thì khách California (sớm hơn 2 tiếng) thấy
  // "còn 1h30 nữa" trong khi kho đã đóng cutoff từ lâu — hứa sai một cách có hệ
  // thống với đúng bang đông đơn nhất. CON SỐ giờ chốt thì lấy từ TIER_DEFS —
  // xem gioChotSameDay(); dòng này từng ghi cứng "2 giờ chiều" trong khi tier1
  // chốt lúc 12 giờ trưa. Trả về Date mà các trường giờ/phút của nó
  // đọc ra là giờ Chicago, nên mọi phép trừ bên dưới đều so trong cùng một hệ.
  function nowCT(){
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    } catch (e) {
      return new Date();
    }
  }

  /* ═══════════════════════════════════════════════════════════════════
     GIAO TRONG NGÀY LÀ CHUYỆN CỦA KHOẢNG CÁCH, KHÔNG PHẢI CỦA VÙNG TIỀN.
     25/8/2026.

     Dải này từng bật câu "⏰ Order within 1h 23m for SAME-DAY delivery in DFW"
     dựa trên `z.zone === 'dfw'`. Nhưng "dfw" trong zone-detection.js là một
     vùng TIỀN — ZIP 75001–76299, tức ngưỡng free-ship $59. Giao trong ngày là
     bán kính 20 dặm quanh kho Arlington TX (gốc = ORIGIN_ZIP của
     ae-delivery-widget.js — TIER_DEFS.tier1; đừng chép số ZIP vào đây). Hai thứ
     khác nhau, trùng tên nên lệch mà không ai thấy.

     templates/page.shipping-policy.liquid có hẳn một khung cảnh báo cho đúng ca
     này: ZIP 75248 (Bắc Dallas) đủ ngưỡng $59 nhưng cách kho hơn 20 dặm nên
     KHÔNG được giao trong ngày (ví dụ lúc viết 25/8 là 75201, đo từ gốc cũ; gốc
     dời 27/9 thì nó thành tier1 nên trang đổi ví dụ). Với bản cũ, khách ở ZIP như thế mở
     trang chủ là thấy đồng hồ đếm ngược cho một lời hứa không áp dụng cho họ.
     Denton 76201 (~35 dặm từ Arlington) cũng vậy.

     Nay hỏi đúng người biết: ae-delivery-widget.js đổi ZIP thành tier rồi ghi
     lên thuộc tính data-tier của thẻ header. Không có tier ⇒ chưa biết khách ở
     đâu ⇒ hiện câu toàn quốc, KHÔNG hứa giao trong ngày.
     ═══════════════════════════════════════════════════════════════════ */
  function tierHienTai(){
    var root = document.querySelector('[data-aef-delivery]');
    return root ? (root.getAttribute('data-tier') || '') : '';
  }

  /* Giờ chốt lấy từ BẢNG GỐC, không chép. Bản cũ ghi cứng 14 giờ trong khi
     tier1 chốt lúc 12 — tức từ 12h đến 14h mỗi ngày, đồng hồ vẫn giục "đặt
     ngay để được giao trong ngày" sau khi giao trong ngày đã đóng. Đọc không
     được thì trả null và cả dải im, chứ không đoán lại con số. */
  function gioChotSameDay(){
    try {
      var d = window.AEF_TIER_DEFS && window.AEF_TIER_DEFS.tier1;
      if (d && typeof d.cutoffHour === 'number') return d.cutoffHour;
    } catch (e) {}
    return null;
  }

  function capNhatDfwPill(){
    var dfw = document.querySelector('[data-aef-dfw]');
    var natl = document.querySelector('[data-aef-natl]');
    if (!dfw || !natl) return;
    var duocSameDay = tierHienTai() === 'tier1' && gioChotSameDay() !== null;
    dfw.hidden = !duocSameDay;
    natl.hidden = duocSameDay;
  }

  function cutoffTick(){
    var open = document.querySelector('[data-cut-open]');
    var closed = document.querySelector('[data-cut-closed]');
    var el = document.querySelector('[data-cutoff]');
    if(!el && !open && !closed) return;

    capNhatDfwPill();

    var gio = gioChotSameDay();
    if (gio === null) {
      /* Không đọc được bảng tier ⇒ không biết giờ chốt ⇒ không nói gì về giao
         trong ngày. Im còn hơn đếm ngược tới một mốc bịa. */
      if (open) open.hidden = true;
      if (closed) closed.hidden = true;
      return;
    }
    var now = new Date(nowCT()), cut = new Date(now);
    cut.setHours(gio,0,0,0);
    var conKip = now < cut;

    // Qua giờ chốt thì ĐỔI HẲN CÂU. Nhét "tomorrow — order now" vào chỗ con số
    // của câu "Order within ___ for SAME-DAY delivery" là vẫn hứa same-day sau khi
    // same-day đã hết — dark pattern, đúng thứ plan cấm.
    if(open) open.hidden = !conKip;
    if(closed) closed.hidden = conKip;
    if(!el || !conKip) return;

    var d = cut - now;
    var h = Math.floor(d/3.6e6), m = Math.floor(d%3.6e6/6e4), s = Math.floor(d%6e4/1e3);
    var str = h + 'h ' + two(m) + 'm ' + two(s) + 's';

    // Cả cụm "Order within {n} for" là MỘT chuỗi dịch, không phải chữ Anh cứng bọc
    // quanh một con số: trật tự từ tiếng Việt khác hẳn ("Đặt trong {n} nữa để được").
    // Bản cũ chỉ thay con số nên bấm VI ra câu nửa Anh nửa Việt.
    // data-mdi18n-n giữ nguồn sự thật để lần đổi ngôn ngữ sau vẽ lại đúng giờ hiện tại.
    el.setAttribute('data-mdi18n-n', str);
    var t = (typeof window.aefMdI18nText === 'function') ? window.aefMdI18nText('md.cut_open_pre', { n: str }) : null;
    el.textContent = t || ('⏰ Order within ' + str + ' for');
  }
  function flashTick(){
    var box = document.querySelector('[data-flash]');
    if(!box) return;
    // Hết ngày cũng tính theo giờ kho, để khách múi giờ khác không thấy đồng hồ
    // nhảy lệch vài tiếng so với lúc deal thật sự kết thúc.
    var now = new Date(nowCT()), end = new Date(now);
    end.setHours(23,59,59,999);
    var d = end - now;
    var h = Math.floor(d/3.6e6), m = Math.floor(d%3.6e6/6e4), s = Math.floor(d%6e4/1e3);
    var b = box.querySelectorAll('b');
    if(b[0]) b[0].textContent = two(h);
    if(b[1]) b[1].textContent = two(m);
    if(b[2]) b[2].textContent = two(s);
  }

  /* ---------------------------------------------------------------- add ---
   * Add-to-cart for the redesign deal cards.
   *
   * The redesign shipped with its own cart file (aef-md-cart.js) that built a
   * SECOND drawer, wrote the cart badge into the same nodes the theme already
   * writes, rewrote every /cart link's text, and intercepted every form submit
   * on the site — including the PDP buy button. That is the exact race the
   * cart anti-regression rules exist to prevent, so it is not shipped.
   *
   * Instead we call the ONE cart entry point the theme already owns,
   * window.aefCartAdd (assets/aef-cart-drawer.js). It posts to /cart/add.js
   * through a serial queue, re-reads /cart.js for authoritative state and
   * dispatches cart:updated — so badge, drawer, free-shipping bar and steppers
   * all repaint from a single source. This file only supplies the click and the
   * button's own feedback.
   * -------------------------------------------------------------------- */
  function label(btn, key, fallback){
    var d = window.aefMdI18nText;
    btn.textContent = (typeof d === 'function' && d(key)) || fallback;
  }

  /* 🔴 17/8 vòng 16 — GỠ `awaitCartConfirm`. TIỀN ĐỀ CỦA NÓ ĐÃ SAI TỪ HAI PHÍA.
   *
   * Chú thích cũ ở đây viết: "window.aefCartAdd nuốt lỗi của chính nó nên lời
   * hứa của nó resolve kể cả khi thêm hỏng — tín hiệu trung thực là sự kiện
   * cart:updated, thứ mà đường ống giỏ CHỈ phát sau khi /cart.js xác nhận".
   * Cả hai mệnh đề đó nay đều sai:
   *
   * 1. `aefCartAdd` ĐÃ trả về boolean từ 16/8 (aef-cart-drawer.js:389 —
   *    `return …then(function () { return httpOk; })`). 6/7 bên gọi đã chuyển
   *    sang đọc giá trị này ở vòng 15; marketdeals là cái DUY NHẤT còn nghe
   *    sự kiện.
   * 2. `cart:updated` KHÔNG phải tín hiệu thành công. Đọc lại chuỗi ở
   *    aef-cart-drawer.js:350-380: nhánh lỗi gọi `showAddErrorToast(r.status)`
   *    rồi `return null` — và chuỗi CHẢY TIẾP xuống `.then(function (line){…})`,
   *    vẫn gọi `/cart.js`, vẫn dispatch `cart:updated`. Nó nói "giỏ vừa được
   *    đọc lại", không nói "món của bạn đã vào".
   *
   * Hậu quả khách thấy: máy chủ trả 422 ⇒ nút hoá XANH "✓ Added" và toast ĐỎ
   * "Không thêm được" hiện CÙNG LÚC, ngược hẳn nhau. Khách tin cái nào?
   *
   * Bỏ luôn được cả cái giới hạn tự thú trong chú thích cũ (sự kiện chung của
   * cả giỏ nên nút A ăn theo kết quả của nút B) — đọc boolean là gắn đúng kết
   * quả với đúng cú bấm.
   */

  function bindAdd(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-aef-add]');
      if(!btn || btn.disabled) return;
      e.preventDefault();

      var id = btn.getAttribute('data-variant');
      if(!id) return;
      // Respect the product's minimum order quantity (custom.min_qty). Adding 1
      // to a min-3 product just makes Shopify reject it at checkout.
      var qty = parseInt(btn.getAttribute('data-min-qty'), 10) || 1;

      var orig = btn.textContent;
      btn.disabled = true;
      // A button with no loading state gets clicked twice — the single most
      // common cause of accidental double-adds.
      label(btn, 'md.adding', 'Adding…');

      /* ═══ 30/8/2026 — BỎ HẲN NHÃN "✓ Added". THẺ THÔI TỰ BÁO ĐÃ THÊM. ═══════
       * Boss: "lúc add hiện dấu tick chứ không hiển thị như những sản phẩm khác".
       * Đúng: trên CÙNG trang chủ, thẻ vẽ bằng snippets/product-card.liquid hoá
       * nút "+" thành ô "− N +" và GIỮ ở đó, còn thẻ này nháy một cái tick 1,1
       * giây rồi quay về "Add to cart" — hai ngôn ngữ khác nhau cho cùng một
       * hành động, và cái tick còn giấu mất con số.
       *
       * Nay việc BÁO đã-thêm thuộc về assets/card-stepper.js: nó nghe
       * `cart:updated` (aefCartAdd phát kèm detail.line = phản hồi thật của
       * /cart/add.js) rồi gỡ `hidden` khỏi ô "− N +" và gắn .is-in-cart lên thẻ;
       * luật CSS trong aef-marketdeals.css ẩn cái nút đi. MỘT NGƯỜI GHI, đúng
       * luật 1 của hàng rào chống hồi quy — file này chỉ còn GỌI thêm hàng.
       *
       * BA thứ CỐ Ý GIỮ NGUYÊN, đừng dọn tiếp:
       *  · "Adding…" — trạng thái ĐANG GỬI, không phải lời khẳng định. Nó là
       *    chốt chống bấm-đôi duy nhất của nút này.
       *  · "Try again" (md.retry) — mặt báo lỗi của khối. scripts/
       *    test-add-paths-honest.js nhận đúng chuỗi này làm bằng chứng "có nói
       *    thật khi hỏng"; gỡ nó là bộ đó đỏ, và đúng ra phải đỏ.
       *  · nhịp 1100ms ở nhánh THÀNH CÔNG. Lúc đó nút đã nằm dưới .is-in-cart
       *    nên không ai nhìn thấy; nó còn tác dụng ở đường dự phòng (aefCartAdd
       *    chưa nạp) — ô "− N +" khi ấy chỉ hiện sau vòng /cart.js ~150ms, và
       *    khoảng trống đó phải có người canh cửa bấm-đôi. */
      /* ĐỌC (không bao giờ GHI) trạng thái của thẻ. Hàng rào chống hồi quy cho
       * phép đúng chừng này: "Listener khác CHỈ được đọc, không ghi". */
      var theChu = btn.closest('[data-aef-stepper-host]');
      var done = function(ok){
        if (!ok) label(btn, 'md.retry', 'Try again');
        /* Nhịp trả nút về nguyên trạng phụ thuộc CÁI CÓ THẬT trên màn hình:
         *  · card-stepper.js đã thay nút bằng ô "− N +" (thẻ đeo .is-in-cart) ⇒
         *    trả về NGAY. Cửa bấm-đôi lúc này do chính cái ô che, không cần
         *    khoá thêm. Chờ 1,1 giây ở đây là để lại một cái bẫy: khách bấm
         *    thùng rác đưa số về 0, card-stepper.js gỡ .is-in-cart, nút hiện
         *    lại — và kẹt `disabled` nốt quãng thời gian còn lại.
         *  · chưa có ô (đường dự phòng: aefCartAdd chưa nạp, ô chỉ hiện sau
         *    vòng /cart.js) ⇒ giữ nguyên 1.100ms, vì lúc đó KHÔNG có ai canh
         *    cửa bấm-đôi ngoài chính cái khoá này. */
        var daCoO = !!(theChu && theChu.classList.contains('is-in-cart'));
        setTimeout(function(){ btn.textContent = orig; btn.disabled = false; },
          ok ? (daCoO ? 0 : 1100) : 1500);
      };

      if (typeof window.aefCartAdd === 'function'){
        // Đọc THẲNG kết quả của chính cú bấm này. `httpOk === false` là máy chủ
        // từ chối; `undefined` (bản cũ chưa vá) coi như không biết → vẫn báo
        // thành công như trước, để không lùi hành vi trên bản chưa đồng bộ.
        Promise.resolve(window.aefCartAdd(id, qty, btn)).then(
          function (ok) { done(ok !== false); },
          function () { done(false); }
        );
      } else {
        // aef-cart-drawer.js is deferred; if a click lands before it defines the
        // API, fall through to the plain form post rather than losing the sale.
        var body = new FormData(); body.append('id', id); body.append('quantity', qty);
        fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{'X-Requested-With':'XMLHttpRequest'}, body: body })
          .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
          .then(function(){
            try { document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ source:'aef-marketdeals' } })); } catch(_){}
            done(true);
          }, function(){ done(false); });
      }
    });
  }

  /* --------------------------------------------------------------- zone ---
   * Nói đúng ngưỡng free-ship của VÙNG người đang xem, thay vì mặc định $59 DFW.
   * Số thật: CA 148 đơn (AOV $41) · NY 80 ($56) · TX chỉ 79 — hơn nửa số đơn nằm
   * ở vùng $79. Hứa "$59" với họ là sai, và hứa "same-day DFW" là nói với ~9%
   * khách. assets/zone-detection.js đã phân vùng theo ZIP; ở đây chỉ đọc kết quả.
   *
   * Không tự viết chữ ra DOM: chỉ đặt lại data-mdi18n-n rồi gọi lại bộ dịch, để
   * câu vẫn đúng ngữ pháp ở cả EN lẫn VI (trật tự từ khác nhau).
   * -------------------------------------------------------------------- */
  function applyZone(z){
    if (!z) return;
    var amount = (z.threshold == null) ? null : '$' + Math.round(z.threshold / 100);

    document.querySelectorAll('[data-aef-zone-amount]').forEach(function(el){
      if (amount == null){
        // Vùng remote (AK/HI/PR) không có ngưỡng — USPS tính theo cân. Đừng bịa
        // ra một con số; đổi hẳn sang câu "tính ở bước thanh toán".
        // 28/9/2026 — vùng KHÔNG GIAO (cờ `giao: false` của zone-detection.js): "tính ở bước
        // thanh toán" cũng là hứa giao ⇒ câu riêng md.freeship_khong_giao (trùng từng chữ với
        // 'zone.khong_giao' của ae-delivery-widget.js — scripts/test-vung-khong-giao-mot-nguon.js CA 6).
        if (!el.hasAttribute('data-aef-tpl-orig')) el.setAttribute('data-aef-tpl-orig', el.getAttribute('data-mdi18n-tpl') || '');
        el.setAttribute('data-mdi18n-tpl', z.giao === false ? 'md.freeship_khong_giao' : 'md.freeship_usps');
      } else {
        var orig = el.getAttribute('data-aef-tpl-orig');
        if (orig) el.setAttribute('data-mdi18n-tpl', orig);
        el.setAttribute('data-mdi18n-n', amount);
      }
    });

    /* Trước đây chỗ này bật dải "giao trong ngày" theo z.zone === 'dfw' — một
       vùng TIỀN. Xem chú thích dài ở trên cutoffTick. Nay đi qua capNhatDfwPill,
       vốn hỏi tier (khoảng cách). Nó cũng được gọi lại mỗi giây trong cutoffTick
       nên tier đến muộn (widget đặt data-tier sau setTimeout 80ms) vẫn bắt kịp. */
    capNhatDfwPill();

    if (typeof window.aefMdI18nApply === 'function') window.aefMdI18nApply();
  }

  function bindZone(){
    // zone-detection.js chạy deferred và có thể đã bắn xong sự kiện trước khi file
    // này gắn listener — nên đọc cả trạng thái đã lưu sẵn.
    if (window.AE_ZONE) applyZone(window.AE_ZONE);
    document.addEventListener('ae-zone-ready', function(e){ applyZone(e.detail); });
  }

  /* ── ĐẶT HẸN THEO CÁI CÓ THẬT TRÊN TRANG, ĐỪNG ĐẶT VÔ ĐIỀU KIỆN ───────────
     Bản cũ đặt thẳng hai setInterval 1 giây/lần trong init(). Hai hàm tick tự
     quay ra sớm khi không thấy phần tử, nhưng CHUÔNG VẪN REO: mỗi giây vẫn là
     4 lượt document.querySelector và một lần đánh thức CPU — vĩnh viễn, vì cả
     file không có lấy một clearInterval.
     Trên trang chủ hôm nay đó là 100% phí: templates/index.json đặt
     show_cutoff:false nên khối [data-cutoff]/[data-cut-open]/[data-cut-closed]
     không được nhả ra, còn [data-flash] thì KHÔNG file .liquid nào của theme
     sinh ra (quét toàn bộ *.liquid = 0 chỗ). Khách để tab nằm im là máy vẫn bị
     đánh thức 2 lần mỗi giây mà không đổi lại một pixel nào.
     VẪN GIỮ cutoffTick(); flashTick(); chạy một lượt lúc init: trang CÓ phần tử
     phải được vẽ ngay chứ không đợi hết giây đầu — hành vi y như cũ.
     VẪN NGHE shopify:section:load: trong Theme Editor, bật lại công tắc
     show_cutoff khiến section được tiêm lại SAU init, lúc đó mới có thứ để đếm.
     Bản cũ bắt được ca này nhờ cái hẹn chạy đời đời; bỏ hẹn mà không nghe sự
     kiện là đổi một BẢO ĐẢM lấy lời hứa suông. Listener nằm im không tốn nhịp
     nào — trên trang khách sự kiện này không bao giờ bắn. */
  var henCutoff = null, henFlash = null;
  function datHen(){
    if (!henCutoff && document.querySelector('[data-cutoff],[data-cut-open],[data-cut-closed]')) {
      henCutoff = setInterval(cutoffTick, 1000);
    }
    if (!henFlash && document.querySelector('[data-flash]')) {
      henFlash = setInterval(flashTick, 1000);
    }
  }
  function nhip(){ cutoffTick(); flashTick(); datHen(); }

  function init(){
    nhip();
    bindAdd();
    bindZone();
    document.addEventListener('shopify:section:load', nhip);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
